// tailwind.config.js で定義している desktop-xmd (1450px)
export const DESKTOP_XMD_BREAKPOINT_PX = 1450

export const MEDIA_QUERY_MAX_DESKTOP_XMD = `(max-width: ${DESKTOP_XMD_BREAKPOINT_PX}px)`
export const MEDIA_QUERY_MIN_DESKTOP_XMD = `(min-width: ${DESKTOP_XMD_BREAKPOINT_PX}px)`
